<template>
    <div  :style="getStyle" class="bg-white" id="externalRatingsCard">
        <vx-card>
            <h2 class="mb-2">
                Dernières évaluations Portail transmises
            </h2>
            <vs-row>
                <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="12"
                >
                    <vs-table
                        no-data-text="Aucune donnée à afficher"
                        style="width:100%"
                        :data="ratings"
                    >
                        <template slot="thead">
                            <vs-th></vs-th>
                            <vs-th>Nom</vs-th>
                            <vs-th>Prénom</vs-th>
                            <vs-th>Evaluation</vs-th>
                            <vs-th>Date transmission</vs-th>
                            <vs-th></vs-th>
                        </template>

                        <template slot-scope="{ data }">
                            <vs-tr v-for="(item, i) in ratings" :key="i" :data="item">
                                <vs-td>
                                    <vs-avatar
                                        v-if="get(item, ':employee.photoUrl')"
                                        size="30px"
                                        :src="get(item, ':employee.photoUrl')"
                                    />
                                    <vs-avatar
                                        v-else
                                        size="30px"
                                        :color="generateColor(get(item, ':employee.name'))"
                                    />
                                </vs-td>
                                <vs-td>
                                    <a :href="'/rh/gestion/personnes/' + get(item, ':employee.id') + '/bilans'" style="color: rgb(98, 98, 98)">
                                        <b>{{ get(item, ":employee.last_name") }}</b>
                                    </a>
                                </vs-td>
                                <vs-td>
                                    <a :href="'/rh/gestion/personnes/' + get(item, ':employee.id') + '/bilans'" style="color: rgb(98, 98, 98)">
                                        <b>{{ get(item, ":employee.first_name") }}</b>
                                    </a>
                                </vs-td>
                                <vs-td>
                                    <a :href="'/rh/gestion/personnes/' + get(item, ':employee.id') + '/bilans'" style="color: rgb(98, 98, 98)">
                                        {{ get(item, ":eval_type") }}
                                    </a>
                                </vs-td>
                                <vs-td>
                                    <a :href="'/rh/gestion/personnes/' + get(item, ':employee.id') + '/bilans'" style="color: rgb(98, 98, 98)">
                                        {{ get(item, ":updated_at") | subStringDate }}
                                    </a>
                                </vs-td>
                                <vs-td class="action">
                                    <vs-button
                                        v-if="
                                            canMulti(
                                                'update',
                                                'ratings',
                                                item.employee.services.length > 0
                                                    ? item.employee.services.map((s) => s.id)
                                                    : null
                                            )
                                        "
                                        :id="'exportRatingEmployee_' + i"
                                        :v-tooltip="'Télécharger'"
                                        color="primary"
                                        type="border"
                                        icon-pack="feather"
                                        icon="icon-download"
                                        @click="() => {
                                            exportExternalRating = item.id;
                                            startExternalExport = 1;
                                        }"
                                    />
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vs-col>
            </vs-row>
            <vs-row>
                <vs-col class="text-right mt-2">
                    <a href="/rh/gestion/bilans#external-rating">Voir plus...</a>
                </vs-col>
            </vs-row>
        </vx-card>
        <ExternalEvalExport
            :rating-id="exportExternalRating"
            :start-export="startExternalExport"
            :hide-button="true"
        />
    </div>
</template>
<script>
import EmployeeRatingForm from '@components/views/rh/gestion/employee/rating/RatingForm';
import ExternalEvalExport from "@components/views/rh/gestion/employee/export/ExternalEvalExport";
export default {
    components: {
        EmployeeRatingForm,
        ExternalEvalExport
    },
    data () {
        return {
            ratings:'',
            exportExternalRating: null,
            startExternalExport: 0
        }
    },
    computed: {
        getStyle () {
            return 'height: 100%; background-size: contain; background-repeat: no-repeat; border: 2px solid #FCE4EC; border-radius: 5px; background-position: center;'
        }
    },
    created() {
        this.loadRatings();
    },
    methods: {
        showResource(resource) {
            this.resetResource();
            this.setResource(resource);
            this.showPopup = true;
        },
        setResource(data) {
            this.resource = JSON.parse(JSON.stringify(data));
        },
        resetResource() {
            this.resource = {
                title: null,
                description: null
            };
        },
        loadRatings() {
            window.axios({
                method: 'get',
                url: '/api/gestion/employees/-1/ratings/statuses',
                params: {statuses:[3], perpage: 4, sortBy: {'created_at': 'desc'}, include: ['employee.services.establishment']},
            })
                .then(response => {
                    response.data.data.forEach(element =>
                    {
                        element['updated_at'] = new Date(element['updated_at']).toLocaleString('fr-FR');
                    });
                    this.ratings = response.data.data;
                })
                .catch((err) => {
                    console.log(err)
                    this.notifyError(err, `Une erreur est survenue`)
                })
        },
    }
}
</script>
